export default "__VITE_ASSET__DoBzXy$M__"